import { defineComponent as _defineComponent } from 'vue'
import {
  AbSection,
  AbContainer,
  AbSectionLayout,
  AbImage,
  AbTitle,
  AbDescription,
} from '../../../ui';
import { FormContainer } from '../../../../forms';
import { type TextAlign } from '../../../../types';
import { computed, ref } from 'vue-demi';

interface Image {
  src: string;
  width?: number | null;
  height?: number | null;
  alt?: string | null;
}

interface Props {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  textAlign?: TextAlign | null;
  formId: string;
  successMessage?: {
    title: string;
    description: string;
    buttonText: string;
  };
  hideFormTitle?: boolean | null;
  hideFormDescription?: boolean | null;
  background?: boolean | null;
  image?: {
    src?: string | null;
    alt?: string | null;
    desktop?: Image | null;
    tablet?: Image | null;
    mobile?: Image | null;
  } | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSectionTextImage',
  props: {
    id: null,
    title: null,
    description: null,
    textAlign: null,
    formId: null,
    successMessage: null,
    hideFormTitle: { type: [Boolean, null] },
    hideFormDescription: { type: [Boolean, null] },
    background: { type: [Boolean, null] },
    image: null
  },
  emits: ["submit", "submit-success", "submit-error", "form-start"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'submit', values: Record<string, any>): void;
  (e: 'submit-success'): void;
  (e: 'submit-error', error: string): void;
  (e: 'form-start'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  textAlign?: TextAlign | null;
  formId: string;
  successMessage?: {
    title: string;
    description: string;
    buttonText: string;
  };
  hideFormTitle?: boolean | null;
  hideFormDescription?: boolean | null;
  background?: boolean | null;
  image?: {
    src?: string | null;
    alt?: string | null;
    desktop?: Image | null;
    tablet?: Image | null;
    mobile?: Image | null;
  } | null;
};

const DEFAULT_TEXT_ALIGN = 'left';





const isHeaderHidden = ref(false);

const handleSubmit = (values: Record<string, any>) => {
  emit('submit', values);
};

const handleSubmitSuccess = () => {
  isHeaderHidden.value = true;
  emit('submit-success');
};

const handleSubmitError = (error: string) => {
  emit('submit-error', error);
};

const handleFormStart = () => {
  emit('form-start');
};

const handleReset = () => {
  isHeaderHidden.value = false;
};

const hasImage = computed(
  () => !!(props.image && (props.image.src || props.image.desktop?.src)),
);

const isHeaderShown = computed(
  () => !!((props.description || props.title) && !isHeaderHidden.value),
);

return { __sfc: true,DEFAULT_TEXT_ALIGN, props, emit, isHeaderHidden, handleSubmit, handleSubmitSuccess, handleSubmitError, handleFormStart, handleReset, hasImage, isHeaderShown, AbSection, AbContainer, AbSectionLayout, AbImage, AbTitle, AbDescription, FormContainer }
}

})